var serialize = function (obj) {
  var str = []
  for (var p in obj) {
    if (p !== 'servicename' && p!== 'section') {
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
      }
    }
  }
  return str.join('&')
}

export const dashboard = {
  state: {
    sysList: []
  },
  getters: {
    getSysData: (state) => {
      return state.sysList
    }
  },
  mutations: {
    setSysList: (state, val) => {
      state.sysList = val
    }
  },
  actions: {
    listGraphListing (context, data) {
      let myHeaders = new Headers()
      let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
      myHeaders.append('Authorization', `Bearer ${token}`)
      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      }
      if (data.codec) data.codec[0] === "ALL" ? delete data.codec : data.codec
      let queryData = serialize(data)
      return new Promise((resolve, reject) => {
        fetch(`${context.getters.getDashUrl}provider/v1/dashboard/${data.section}?${queryData}`, requestOptions)
          .then((response) => {
            if (response.ok) {
              resolve(response.json())
            } else {
              reject(response)
            }
          }).catch(error => {
            reject(error)
          })
      })
    },
    listSummaryListing (context, data) {
      let myHeaders = new Headers()
      let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
      myHeaders.append('Authorization', `Bearer ${token}`)
      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      }
      const PROVIDERID = 'ALL'
      return new Promise((resolve, reject) => {
        fetch(`${context.getters.getDashUrl}provider/v1/dashboard/summary`, requestOptions)
          .then((response) => {
            if (response.ok) {
              resolve(response.json())
            } else {
              reject(response)
            }
          }).catch(error => {
            reject(error)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/dashboard.js